<template>
    <div class="tab-mission-wrap section-space--mt_80">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="tab-mission-image">
                    <img src="../../assets/img/trustami/visual_collaboration.svg" alt="image" class="img-fluid">
                </div>
            </div>
            <div class="col-lg-6">
                <div class="tab-content-inner">
                    <h4 class="font-weight--light">{{ $t("sent.request") }}</h4>
                    <p class="dec mt-10 mb-10 pre">
                        {"text": "Na toll! Jetzt ist die Waschmaschine, von der wir dachten, sie sei so gut, schon wieder ausgefallen!"}
                    </p>

                    <h4 class="font-weight--light">{{ $t("sent.response") }}</h4>
                    <p class="dec mt-10 pre">
                        {"polarity": "Negativ", "score": -0.6}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TabContentThree'
}
</script>
